import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["type", "title", "variant", "icon", "suffixIcon", "onClick", "buttonSize", "disabled", "isUnderLined", "fontColor", "fullwidth", "children", "borderLess", "loading", "isRoundedFull", "twStyle", "withLabelUnderneathIcon", "loaderSize", "fitContent", "fontWeight", "testId"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { forwardRef } from 'react';
import { buttonIconMap, variantMap, fontColorMap } from './button.constant'; // --> types

import { Spinner, fontWeightMap } from '../..'; // --> main components
// eslint-disable-next-line @typescript-eslint/no-explicit-any

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Button = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'normal' : _props$variant,
      icon = props.icon,
      suffixIcon = props.suffixIcon,
      handleClick = props.onClick,
      buttonSize = props.buttonSize,
      disabled = props.disabled,
      isUnderLined = props.isUnderLined,
      fontColor = props.fontColor,
      fullwidth = props.fullwidth,
      children = props.children,
      borderLess = props.borderLess,
      loading = props.loading,
      isRoundedFull = props.isRoundedFull,
      twStyle = props.twStyle,
      withLabelUnderneathIcon = props.withLabelUnderneathIcon,
      _props$loaderSize = props.loaderSize,
      loaderSize = _props$loaderSize === void 0 ? 'sm' : _props$loaderSize,
      fitContent = props.fitContent,
      _props$fontWeight = props.fontWeight,
      fontWeight = _props$fontWeight === void 0 ? 'semibold' : _props$fontWeight,
      testId = props.testId,
      rest = _objectWithoutProperties(props, _excluded);

  var iconSVGElement = icon ? /*#__PURE__*/_jsx("span", {
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    },
    children: buttonIconMap[icon]
  }) : null;
  return /*#__PURE__*/_jsx(StyledButton, _objectSpread(_objectSpread({
    type: type,
    disabled: disabled,
    buttonSize: buttonSize,
    variant: variant,
    onClick: function onClick(e) {
      return handleClick && handleClick(e);
    },
    suffixIcon: suffixIcon,
    fontColor: fontColor,
    fullwidth: fullwidth,
    borderless: borderLess ? '1' : '0',
    loading: loading ? '1' : '0',
    isroundedfull: isRoundedFull ? '1' : '0',
    twstyle: twStyle,
    $withLabelUnderneathIcon: withLabelUnderneathIcon,
    fitContent: fitContent,
    withIconOnly: !(title || children),
    fontWeight: fontWeight,
    ref: ref,
    "data-cy": testId
  }, rest), {}, {
    children: loading ? /*#__PURE__*/_jsx(Spinner, {
      color: "primary",
      size: loaderSize
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(ButtonTitleWrapper, {
        id: "button-label",
        $withLabelUnderneathIcon: withLabelUnderneathIcon,
        children: [iconSVGElement, title || children ? /*#__PURE__*/_jsx(ButtonTitle, {
          id: "button-label",
          isUnderLined: isUnderLined,
          children: title || children
        }) : null]
      }), suffixIcon ? /*#__PURE__*/_jsx(_StyledSpan, {
        id: "button-icon",
        children: buttonIconMap[suffixIcon]
      }) : null]
    })
  }));
});
export default Button; // --> styled components

var StyledButton = /*#__PURE__*/_styled.button.withConfig({
  displayName: "button__StyledButton",
  componentId: "sc-fgisgm-0"
})(["", ";", ";", ";", ";", "};", ";", " ", " ", " ", " ", " ", " ", " ", " ", ""], {
  "position": "relative",
  "display": "inline-flex",
  "width": "max-content",
  "maxWidth": "28rem",
  "cursor": "pointer",
  "alignItems": "center",
  "borderRadius": "0.5rem",
  "paddingLeft": "20px",
  "paddingRight": "20px",
  "paddingTop": "14px",
  "paddingBottom": "14px",
  "fontSize": "1rem",
  "lineHeight": "15.4px",
  "fontWeight": "600",
  "@media (min-width: 768px)": {
    "fontSize": "0.875rem",
    "lineHeight": "15.4px"
  },
  "@media (min-width: 1024px)": {
    "fontSize": "0.875rem",
    "lineHeight": "15.4px"
  }
}, function (_ref) {
  var variant = _ref.variant;

  switch (variant) {
    case 'custom':
      return {
        "fontWeight": "600"
      };

    case 'ghost':
      return {
        "height": "2rem",
        "maxWidth": "fit-content",
        "alignSelf": "center",
        "padding": "0.125rem"
      };

    default:
      return {
        ":focus": {
          "outline": "2px solid transparent",
          "outlineOffset": "2px",
          "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
          "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
          "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
          "--tw-ring-opacity": "1",
          "--tw-ring-color": "rgb(232 247 85 / var(--tw-ring-opacity))"
        }
      };
  }
}, function (_ref2) {
  var variant = _ref2.variant;
  return variantMap[variant];
}, function (_ref3) {
  var suffixIcon = _ref3.suffixIcon;
  return suffixIcon ? {
    "justifyContent": "space-between"
  } : {
    "justifyContent": "center"
  };
}, function (_ref4) {
  var fontColor = _ref4.fontColor;
  return fontColor ? fontColorMap[fontColor] : {};
}, function (_ref5) {
  var fullwidth = _ref5.fullwidth;
  return fullwidth ? {
    "width": "100%",
    "maxWidth": "100%"
  } : {};
}, function (_ref6) {
  var borderless = _ref6.borderless;
  return borderless === '1' ? {
    "borderWidth": "0px"
  } : {};
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled ? {
    "pointerEvents": "none",
    "cursor": "not-allowed !important",
    "borderStyle": "none",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(243 244 246 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(156 163 175 / var(--tw-text-opacity))",
    "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
    "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
    "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)"
  } : {};
}, function (_ref8) {
  var loading = _ref8.loading;
  return loading === '1' ? {
    "pointerEvents": "none"
  } : {};
}, function (_ref9) {
  var isroundedfull = _ref9.isroundedfull;
  return isroundedfull === '1' ? {
    "borderRadius": "9999px",
    "padding": "0.5rem"
  } : {};
}, function (_ref10) {
  var $withLabelUnderneathIcon = _ref10.$withLabelUnderneathIcon;
  return $withLabelUnderneathIcon ? {
    "--tw-text-opacity": "1",
    "color": "rgb(156 163 175 / var(--tw-text-opacity))"
  } : {};
}, function (_ref11) {
  var fitContent = _ref11.fitContent;
  return fitContent ? {
    "minWidth": "fit-content"
  } : {};
}, function (_ref12) {
  var withIconOnly = _ref12.withIconOnly;
  return withIconOnly ? {
    "paddingLeft": "14px",
    "paddingRight": "14px",
    "paddingTop": "14px",
    "paddingBottom": "14px"
  } : {};
}, function (_ref13) {
  var fontWeight = _ref13.fontWeight;
  return fontWeight ? fontWeightMap[fontWeight] : {};
}, function (_ref14) {
  var twstyle = _ref14.twstyle;
  return twstyle;
});

var ButtonTitle = /*#__PURE__*/_styled.span.withConfig({
  displayName: "button__ButtonTitle",
  componentId: "sc-fgisgm-1"
})(["", " ", ""], {
  "cursor": "pointer"
}, function (_ref15) {
  var isUnderLined = _ref15.isUnderLined;
  return isUnderLined ? {
    "textDecorationLine": "underline",
    "textUnderlineOffset": "4px"
  } : {};
});

var ButtonTitleWrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "button__ButtonTitleWrapper",
  componentId: "sc-fgisgm-2"
})(["", " ", ""], {
  "display": "flex",
  "cursor": "pointer",
  "alignItems": "center",
  "gap": "0.5rem"
}, function (_ref16) {
  var $withLabelUnderneathIcon = _ref16.$withLabelUnderneathIcon;
  return $withLabelUnderneathIcon ? {
    "flexDirection": "column",
    "alignItems": "center",
    "gap": "0px"
  } : {};
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "button___StyledSpan",
  componentId: "sc-fgisgm-3"
})({
  "marginLeft": "0.5rem"
});